query DateCalcTermNights($days: Int!, $startDate: Date!) {
  dateCalcTermNights(days: $days, startDate: $startDate)
}
